import { authenticatedFastApiAxiosInstance } from "@/lib/data/http";
import {
  type APIResponse,
  type MatterTag,
  type MatterTagConnection,
} from "@/lib/types";
import { baseFastApiMatterRoute } from "./matter";

export const createMatterTagConnectionV1 = (
  data: Pick<MatterTagConnection, "matterId" | "tagId">,
) => {
  return authenticatedFastApiAxiosInstance
    .post<
      APIResponse<MatterTag>
    >(`${baseFastApiMatterRoute}/tags/connections`, data)
    .then((res) => res.data);
};

export const deleteMatterTagConnectionV1 = (
  data: Pick<MatterTagConnection, "matterId" | "id">,
) => {
  return authenticatedFastApiAxiosInstance
    .delete<
      APIResponse<MatterTagConnection>
    >(`${baseFastApiMatterRoute}/tags/connections/${data.id}`)
    .then((res) => res.data);
};
